/* eslint-disable no-shadow */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withTheme } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import classNames from 'classnames';
import VolumeMute from '../../../assets/images/volumeMute.svg';
import VolumeDown from '../../../assets/images/volumeDown.svg';
import VolumeUp from '../../../assets/images/volumeUp.svg';
import MicOn from '../../../assets/images/micOn.svg';
import MicOff from '../../../assets/images/micOff.svg';
import { setMicSelected, setOnlyInternalAudio, startRecord } from '../../actions';
import { addNotification } from '../../actions/cc-mode';
import { isInternalAudio } from '../../utils/internalAudio';
import { getSnack } from '../../utils/snackbar';
const styles = (theme) => ({
    root: {
        width: '150px',
    },
    volumeImage: {
        width: 19,
    },
    button: {
        border: 'none',
        margin: 0,
        outline: 'none',
        padding: 3,
        background: 'rgba(0, 0, 0, 0.5)',
        userSelect: 'none',
        '&:hover': {
            backgroundColor: theme.palette.ava.grey5,
        },
    },
    buttonLeft: {
        borderBottomLeftRadius: 5,
        borderTopLeftRadius: 5,
    },
    buttonRight: {
        borderBottomRightRadius: 5,
        borderTopRightRadius: 5,
    },
    controllers: {
        position: 'relative',
        zIndex: 100,
        WebkitAppRegion: 'no-drag',
        display: 'flex',
        background: theme.palette.ava.grey5,
        borderRadius: 5,
        '& > :not(:last-child)': {
            marginRight: 1,
        },
    },
    volumeDisplay: {
        borderRadius: 5,
        position: 'relative',
        left: 12,
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 4,
        transition: 'opacity 300ms',
        opacity: 0,
    },
    volume: {
        position: 'relative',
        top: 2,
        left: -4,
        backgroundColor: '#18191A',
        borderRadius: 5,
        display: 'flex',
        flexDirection: 'row',
        overflow: 'hidden',
        border: '1px solid #18191A',
    },
    volumeRectangle: {
        flexGrow: 0,
        flexShrink: 0,
        backgroundColor: 'white',
        height: 8,
        width: 12,
        marginRight: 1,
    },
    volumeOffRectangle: {
        flexGrow: 0,
        flexShrink: 0,
        backgroundColor: '#18191A',
        height: 8,
        width: 12,
        marginRight: 1,
    },
});
class ScribeVolumeController extends React.Component {
    constructor(props) {
        super(props);
        this.handleMicOnOf = () => {
            const { addNotification, electronCaptionMode, onlyInternalAudio, setOnlyInternalAudio, t, recording, audioParamsSent, startRecord, } = this.props;
            if (recording && audioParamsSent) {
                setOnlyInternalAudio(!onlyInternalAudio);
                if (window.isElectron && electronCaptionMode) {
                    addNotification({
                        text: t(!onlyInternalAudio ? 'microphone.soundIsNotGettingCaptioned' : 'microphone.soundIsGettingCaptioned'),
                        timestamp: Date.now(),
                        type: 'default',
                    });
                }
                else {
                    getSnack(this.props)(t(!onlyInternalAudio ? 'microphone.soundIsNotGettingCaptioned' : 'microphone.soundIsGettingCaptioned'));
                }
            }
            else {
                setOnlyInternalAudio(false);
                startRecord();
            }
        };
        this.state = {
            volume: parseInt(parseFloat(window.electronIPC.sendSyncGetVolume()), 10),
            showVolume: false,
        };
    }
    setVolume(volume) {
        let newVolume = volume;
        if (newVolume > 100)
            newVolume = 100;
        if (newVolume < 0)
            newVolume = 0;
        this.setState({ volume: newVolume, showVolume: true });
        window.electronIPC.sendChangeVolume(newVolume);
        this.lastVolumeTouchAt = new Date().getTime();
        setTimeout(() => {
            if (new Date().getTime() - this.lastVolumeTouchAt >= 2000) {
                this.setState({ showVolume: false });
            }
        }, 2000);
    }
    render() {
        var _a;
        const { classes, electronCaptionMode, className, onlyInternalAudio, theme, audioParamsSent, recording, selectedCaptions, availableMics, micIdSelected, status, } = this.props;
        const { volume, showVolume } = this.state;
        const volumeRectangles = [];
        for (let i = 0; i < 10; i += 1) {
            if (i < volume / 10) {
                volumeRectangles.push(React.createElement("div", { key: i, className: classes.volumeRectangle }));
            }
            else {
                volumeRectangles.push(React.createElement("div", { key: i, className: classes.volumeOffRectangle }));
            }
        }
        const controllerStyle = {};
        if (!electronCaptionMode) {
            controllerStyle.position = 'absolute';
            controllerStyle.left = 10;
            controllerStyle.top = 25;
        }
        const volumeStyle = {
            opacity: showVolume ? 1 : 0,
        };
        if (!electronCaptionMode) {
            volumeStyle.position = 'absolute';
            volumeStyle.left = 127;
            volumeStyle.top = 23;
        }
        let background = theme.palette.ava.grey;
        if (recording && audioParamsSent) {
            if (onlyInternalAudio) {
                background = '#DE423E';
            }
            else if (selectedCaptions === undefined) {
                if (((_a = status === null || status === void 0 ? void 0 : status.scribe) === null || _a === void 0 ? void 0 : _a.status) === 'ongoing') {
                    background = theme.palette.ava.green;
                }
                else {
                    background = theme.palette.ava.gradientBlue;
                }
            }
            else if (selectedCaptions === 'premium') {
                background = theme.palette.ava.gradientBlue;
            }
            else {
                background = theme.palette.ava.blue;
            }
        }
        else {
            background = theme.palette.ava.grey;
        }
        const currentMic = availableMics && availableMics.find((mic) => mic.value === micIdSelected);
        const isAvaMic = isInternalAudio(currentMic);
        return (React.createElement("div", { className: className },
            electronCaptionMode && (React.createElement("div", { className: classes.volumeDisplay, style: volumeStyle },
                React.createElement("div", { className: classes.volume }, volumeRectangles))),
            React.createElement("div", { className: classes.controllers, style: controllerStyle },
                isAvaMic && (React.createElement("button", { type: "button", className: `${classes.button} ${classes.buttonLeft}`, onClick: this.handleMicOnOf, onMouseDown: (e) => e.stopPropagation(), style: { background } },
                    React.createElement("img", { src: onlyInternalAudio && recording && audioParamsSent ? MicOff : MicOn, alt: "mute mic", className: classes.volumeImage }))),
                React.createElement("button", { type: "button", className: classNames(classes.button, {
                        [classes.buttonLeft]: !isAvaMic,
                    }), onMouseDown: (e) => e.stopPropagation(), onClick: () => this.setVolume(0) },
                    React.createElement("img", { src: VolumeMute, alt: "volume mute", className: classes.volumeImage })),
                React.createElement("button", { type: "button", className: classes.button, onMouseDown: (e) => e.stopPropagation(), onClick: () => this.setVolume(volume - 10) },
                    React.createElement("img", { src: VolumeDown, alt: "volume down", className: classes.volumeImage })),
                React.createElement("button", { type: "button", className: `${classes.button} ${classes.buttonRight}`, onMouseDown: (e) => e.stopPropagation(), onClick: () => this.setVolume(volume + 10) },
                    React.createElement("img", { src: VolumeUp, alt: "volume up", className: classes.volumeImage }))),
            !electronCaptionMode && (React.createElement("div", { className: classes.volumeDisplay, style: volumeStyle },
                React.createElement("div", { className: classes.volume }, volumeRectangles)))));
    }
}
const mapStateToProps = ({ scribeConversation: { micIdSelected, availableMics, onlyInternalAudio, recording, status }, scribeSession: { selectedCaptions, audioParamsSent }, }) => ({
    micIdSelected,
    availableMics,
    onlyInternalAudio,
    selectedCaptions,
    audioParamsSent,
    recording,
    status,
});
const mapDispatchToProps = {
    addNotification,
    setMicSelected,
    setOnlyInternalAudio,
    startRecord,
};
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withTheme(withTranslation()(withSnackbar(ScribeVolumeController)))));
